import { useEffect } from 'react';
import { useGetLocationsQuery } from 'services/locationsApi';
import { useGetShoppingCartQuery } from 'services/shoppingCartApi';

import { GridItem, SimpleGrid } from '@chakra-ui/react';

import { useAppDispatch } from 'store/hooks';
import { setIsPreferencesMenuEnabled } from 'store/reducers/cartSlice';

import { ContentFilter } from 'types';

import { ContentLoader } from '../../../ContentLoader';
import { ShipmentMethodItem } from '../ShipmentMethodItem';

interface PickUpLocationProps {
  onClick: (id: number) => void;
  activeId?: number | null;
}
const PickUpLocation = ({ onClick, activeId }: PickUpLocationProps) => {
  const dispatch = useAppDispatch();
  const { isFetching } = useGetShoppingCartQuery('');
  const { data: locationsList = [], isLoading } = useGetLocationsQuery(
    ContentFilter.PickUp
  );

  useEffect(() => {
    dispatch(setIsPreferencesMenuEnabled(false));
  }, [dispatch]);

  return (
    <SimpleGrid gap='10px' columns={{ base: 1, lg: 2 }}>
      {isLoading ? (
        <GridItem colSpan={2} justifyContent='center'>
          <ContentLoader isLoading={!isFetching} label='' minHeight='300px' />
        </GridItem>
      ) : (
        locationsList.map((location) => (
          <ShipmentMethodItem
            key={location?.id}
            label={location.name}
            description={location.addr1}
            onClick={() => onClick(location?.id)}
            isActive={location?.id === activeId}
            itemLatitude={location?.latitude}
            itemLongitude={location?.longitude}
            isIcon
          />
        ))
      )}
    </SimpleGrid>
  );
};

export default PickUpLocation;
